import * as React from "react";
import { ConfirmationLayer } from "../ConfirmationLayer";
import { useRegisterServiceBundle } from "./useRegisterServiceBundle";
import { getEnvName } from "../../utils/getEnvName";
import { ServiceContext } from "../../context/ServiceContext";
import { useNotifyFsbOscar } from "./useNotifyOscar";
import { shortenErrorMsg } from "../../utils/errorUtils";
export const registerServiceBundleAction = (layerManager, releases, reload) => {
    return (env, version) => {
        const chosenReleases = releases.filter((r) => r.version === version);
        const release = chosenReleases.length === 1 ? chosenReleases[0] : undefined;
        if (!release) {
            return;
        }
        layerManager.openAlert(React.createElement(LayerContent, { env: env, release: release, reload: reload }));
    };
};
const LayerContent = (props) => {
    const { env, release, reload } = props;
    const layerManager = React.useContext(ServiceContext).layerManager;
    const register = useRegisterServiceBundle(release.url, env);
    const notifyOscar = useNotifyFsbOscar(env, release.version);
    const handleCancel = () => {
        layerManager.closeAlert();
    };
    const handleConfirm = (register) => async () => {
        try {
            const value = await register();
            if (!value.data?.registerFeatureServiceBundle?.success) {
                console.error("registration failed", value.data?.registerFeatureServiceBundle?.msg);
                layerManager.closeAlert();
                layerManager.openError("Technical Error", shortenErrorMsg(value.data?.registerFeatureServiceBundle?.msg));
                return;
            }
            else {
                try {
                    await notifyOscar();
                }
                catch (e) {
                    console.warn("failed to notify OSCAR", e);
                }
                reload(env, release?.version || "");
            }
        }
        catch (e) {
            console.error("failed to register fa", e);
            layerManager.closeAlert();
            layerManager.openError("Technical Error", shortenErrorMsg(e instanceof Error ? e.message : String(e)));
            return;
        }
        layerManager.closeAlert();
    };
    const envName = getEnvName(env);
    return (React.createElement(ConfirmationLayer, { text: ` Do you want to register ${release.version} (${release.name}) on ${envName}?`, headline: "Registration", handleCancel: handleCancel, handleConfirm: handleConfirm(register) }));
};
